<template>
  <div class="mb-30">
    <header class="main-header vertical-header bg-white d-flex align-items-center justify-content-between" >
      <div class="menu-toggle vertical-toggle" @click="mobileSidebar">
        <div></div>
        <div></div>
        <div></div>
      </div>

    <div class="d-flex align-items-center ml-3 mr-auto title-top-bar">
        <breadcumb :pages="$route.meta.pages" />
        <router-view name="topBar"/>
    </div>

    <div class="header-part-right">
      <!-- Notification -->
      <!-- Notification End -->

      <!-- User avatar dropdown -->
      <div class="dropdown">
        <b-dropdown
          id="dropdown-1"
          right
          class="m-md-2 user col align-self-end"
          toggle-class="text-decoration-none"
          no-caret
          variant="link"
        >
          <template slot="button-content">
            <img
                v-if="user"
                :src="user.photoURL || 'https://ui-avatars.com/api/?name=' + user.displayName + '&rounded=true&background=e65862&color=ffffff'"
                id="userDropdown"
                alt
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            />
          </template>

          <div class="dropdown-menu-right" aria-labelledby="userDropdown">
            <div class="dropdown-header">
              <i class="i-Lock-User mr-1"></i> {{ user && user.displayName || '' }}
            </div>
            <router-link
                :to="{ name: 'Profile' }"
                class="dropdown-item"
            >
                Perfil
            </router-link>
            <router-link
                v-if="!isUser"
                :to="{ name: 'Plan' }"
                class="dropdown-item"
            >
                Plano
            </router-link>
            <router-link
                v-if="!isUser"
                :to="{ name: 'Account' }"
                class="dropdown-item"
            >
                Conta
            </router-link>
            <a class="dropdown-item" href="#" @click.prevent="signOut">Sair</a>
          </div>
        </b-dropdown>
      </div>
    </div>
    </header>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters(['getVerticalCompact', 'getVerticalSidebar', 'getSideBarToggleProperties']),
        user () {
            return this.$store.getters['auth/user']
        },
        isUser () {
            return this.user && this.user.claims.level === 'user'
        },
    },
    methods: {
        ...mapActions(['switchSidebar', 'sidebarCompact', 'removeSidebarCompact', 'mobileSidebar']),
        signOut () {
            this.$store.dispatch('auth/signOut')
        },
    },
}
</script>>

<style lang="scss">
.main-header .notification-dropdown {
    .dropdown-header,
    .dropdown-footer {
        background-color: #eee;
    }
}
.title-top-bar {
    width: 500px;
}
</style>
